package com.pincer.core.contracts

import com.pincer.core.PincerException

class RequestContractFromString(val contract: StringContract): RequestContract {

    override suspend fun process(request: PincerRequest): PincerResponse {
        val response = PincerResponse.parse(contract.process(request.json()))
        if (response.req != request.id) {
            throw PincerException("Request code mismatch ${response.req} != ${request.id}, request:${request.json()} response:${response.json()}")
        }
        return response
    }

}
